import { Component, ElementRef } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Sdk } from '../../core/sdk.service';
import { Transaction } from '../../transaction-store/transaction';
import { BillingInfo } from '../../transaction-store/billing-info';

@Component({
  selector: 'google-pay',
  template: `
  <div class="row">
    <div class="col">
      <div
        class="info-label"
        [ngClass]="{
          'validation-failed': showValidation && !hasToken()
        }"
        >{{validationLabel}}
      </div>
    </div>
  </div>
  `
})
export class GooglePayComponent {
  button: HTMLElement;
  showValidation: boolean;
  billingContactName: string;

  @Select() transaction$: Observable<Transaction>;
  @Select() billingInfo$: Observable<BillingInfo>;

  constructor(
    private element: ElementRef,
    private sdk: Sdk
  ) {
    const gpayContainer = this.element.nativeElement;
    const btn = this.sdk.googlePayResponse.button;
    if (gpayContainer && !gpayContainer.hasChildNodes() && btn) {
      gpayContainer.appendChild(btn);
    }

    this.transaction$.subscribe(item => {
      this.showValidation = item.validation;
    });

    this.billingInfo$.subscribe(item => {
      this.billingContactName = item.firstName;
    });
  }

  public hasToken() {
    const cardConnectResponse = this.sdk.googlePayResponse.cardConnectResponse;
    if (!cardConnectResponse) {
      return false;
    }
    return cardConnectResponse.token !== null;
  }

  get validationLabel() {
    const cardDescription = this.sdk.googlePayResponse.cardDescription;
    if (this.hasToken() && this.billingContactName) {
      return `${this.billingContactName}, your payment info (${cardDescription}) has been captured`;
    }

    return 'Click Google Pay button to capture your payment info';
  }
}
